/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseStartupChallengeStatus,
    PressReleaseStartupChallengeStatusFromJSON,
    PressReleaseStartupChallengeStatusFromJSONTyped,
    PressReleaseStartupChallengeStatusToJSON,
} from './PressReleaseStartupChallengeStatus';

/**
 * GET /press_release/startup_challenge_status
 * @export
 * @interface GetStartupChallengeStatusResponse
 */
export interface GetStartupChallengeStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof GetStartupChallengeStatusResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetStartupChallengeStatusResponse
     */
    message: string;
    /**
     * 
     * @type {PressReleaseStartupChallengeStatus}
     * @memberof GetStartupChallengeStatusResponse
     */
    data: PressReleaseStartupChallengeStatus;
}

export function GetStartupChallengeStatusResponseFromJSON(json: any): GetStartupChallengeStatusResponse {
    return GetStartupChallengeStatusResponseFromJSONTyped(json, false);
}

export function GetStartupChallengeStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStartupChallengeStatusResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressReleaseStartupChallengeStatusFromJSON(json['data']),
    };
}

export function GetStartupChallengeStatusResponseToJSON(value?: GetStartupChallengeStatusResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressReleaseStartupChallengeStatusToJSON(value.data),
    };
}

